// LayoutCustomer.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

export default function LayoutCustomer() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Ferme automatiquement la sidebar mobile lors d'un changement de route
  useEffect(() => {
    if (sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex flex-col min-md:flex-row">
      {/* Backdrop mobile – plus élégant avec blur */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm min-md:hidden transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <Sidebar 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={setSidebarOpen} 
      />

      {/* Contenu principal */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Navbar fixe en haut */}
        <Navbar setSidebarOpen={setSidebarOpen} />

        {/* Contenu scrollable */}
        <main 
          className="
            flex-1 overflow-y-auto overflow-x-hidden 
            bg-gradient-to-b from-gray-50 to-white 
            dark:from-gray-950 dark:to-gray-900
            pt-1
          "
        >
          {/* Padding responsive + max-width pour un look premium */}
          <div className="
            mx-auto w-full 
            px-4 min-sm:px-6 min-lg:px-8 
            py-6 min-sm:py-8 min-lg:py-10 
            max-w-screen-2xl
          ">
            {/* Transition douce lors du changement de page */}
            <div 
              key={location.pathname}
              className="animate-fade-in"
            >
              <Outlet />
            </div>
          </div>
        </main>
      </div>

      {/* Styles d'animation (à mettre dans votre fichier CSS global ou tailwind config) */}
      {/* 
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.4s ease-out forwards;
        }
      */}
    </div>
  );
}